import { Link } from "react-router-dom";
import { ArrowRight, XCircle } from "lucide-react";
import { useI18n } from "@/i18n";

export default function OrderCancelled() {
  const { t } = useI18n();
  return (
    <div className="order-result-page">
      <div className="container max-w-lg text-center">
        <XCircle size={64} className="mx-auto mb-6" style={{ color: "var(--color-terracotta)" }} />
        <h1 className="text-3xl mb-3" style={{ fontFamily: "var(--font-display)", color: "var(--color-charcoal)" }}>{t.orderConfirmation.cancelledTitle}</h1>
        <p className="text-lg mb-8" style={{ color: "var(--color-text-muted)" }}>
          {t.orderConfirmation.cancelledSubtitle}
        </p>
        <Link to="/gallery" className="btn-primary">{t.orderConfirmation.backToGallery} <ArrowRight size={16} /></Link>
      </div>
    </div>
  );
}
